import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { Card } from '@payaca/ambrosia';
import RouterTabs, {
  type TabPanel,
} from '@payaca/components/routerTabs/RouterTabs';
import { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useGetUser } from '../../../api/queries/user/useGetUser';
import { useTranslation } from '../../../i18n';
import UserPageHeaders from './components/UserPageHeaders';
import UserProfile from './components/UserProfileTab';

type Props = {
  userId: number;
};
const UserPage: FC<Props> = (props) => {
  const translate = useTranslation();
  const { userId } = props;
  const { data: userData } = useGetUser(userId);
  const user = userData?.user;

  const routerTabPanels = useMemo<TabPanel[]>(() => {
    return [
      {
        icon: 'user-03',
        label: 'Profile',
        slug: 'profile',
        render: () => <UserProfile />,
      },
    ];
  }, []);

  return (
    <>
      <Helmet
        title={translate('pages.userProfile.title', {
          name: user?.fullName || '',
        })}
      />
      <AuthenticatedPageWrapper
        breadcrumbItems={[
          { label: 'Users', to: '/companySettings/team/users' },
          { label: user?.fullName || '' },
        ]}
      >
        <RouterTabs panels={routerTabPanels}>
          <div className="mx-auto flex w-full max-w-screen-xl flex-col p-6 pb-4">
            <Card>
              <Card.Body>
                <UserPageHeaders />
                <RouterTabs.Nav
                  className="md:-mb-5 mt-7"
                  defaultTabSlug="profile"
                />
              </Card.Body>
            </Card>
          </div>

          <div className="mx-auto w-full max-w-screen-xl p-6 pt-0">
            <RouterTabs.Panels />
          </div>
        </RouterTabs>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default UserPage;
